import * as React from 'react';
import { observer } from 'mobx-react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface PaymentModeViewProps {
	label?: string;
	value: number | null;
	onChanged: (number: number | null) => void;
	mode: ControlMode;
	required?: boolean;
}

@observer
export class PaymentModeEditorView extends React.Component<PaymentModeViewProps, {}> {
	constructor(props: Readonly<PaymentModeViewProps>) {
		super(props);
	}

	render(): React.ReactNode {
		return (
			<DropdownView
				label={this.props.label === undefined ? 'Payment mode' : this.props.label}
				model={this.props.value}
				required={this.props.required}
				disabled={this.props.mode == 'display'}
				onChanged={(item) => { this.props.onChanged(item != null ? item.value : null); }}
				options={[
					{ value: 0, label: 'Direct' },
					{ value: 1, label: 'Indirect' }
				]}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quotes/form/parts/payment-mode-editor.view.tsx